<template>
  <SelectorPanel
    type="latest"
    text="Latest"
    :disabled="disabled"
    :force-close="forceClose"
    :url-path="urlPath"
    @open="handleClickOpen"
  >
    <SelectorPanelHeader
      type="latest"
      title="Latest"
      class="pb-2"
      dense
      @click-close="handleClickClose"
    >
    </SelectorPanelHeader>

    <div class="screenshot-btn-holder">
      <v-btn outlined small @click="handleScreenshotClick">
        <v-icon class="mr-2 pull-right" size="15">fas fa-camera</v-icon>
        Screenshot
      </v-btn>
    </div>

    <Latest
      v-if="renderLatest"
      :opened-timestamp="openedTimestamp"
      @close="handleClickClose()"
    />

    <v-overlay :absolute="true" :value="screenShotting">
      <div class="copy-overlay-indicator">
        <v-icon size="48" color="white">fas fa-check</v-icon>
        <div><strong>Screenshot Captured</strong></div>
      </div>
    </v-overlay>
  </SelectorPanel>
</template>

<script>
import html2canvas from "html2canvas";
import { mapGetters } from "vuex";

import { EVENT_ACTIONS, LATEST_CATEGORIES } from "@/common/constants/analytics";
import { MODULE_PREFIX_HOME } from "@/store";

export default {
  name: "LatestSelector",
  components: {
    SelectorPanel: () => import("@/components/common/SelectorPanel"),
    Latest: () => import("@/components/latest/Latest"),
    SelectorPanelHeader: () =>
      import("@/components/common/SelectorPanelHeader"),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    forceClose: null,
    openedTimestamp: null,
    screenShotting: false,
    urlPath: "/latest",
  }),
  computed: {
    ...mapGetters({
      selectorPanel: MODULE_PREFIX_HOME + "selectorPanel",
    }),
    renderLatest() {
      //Maybe it makes sense to have a 'on once' so we don't need to make requests each time its opened
      //on the other hand this keeps the content fresh
      return (
        this.selectorPanel &&
        this.selectorPanel.selected === "latest" &&
        this.selectorPanel.visible
      );
    },
  },
  methods: {
    handleClickClose() {
      this.forceClose = new Date().toISOString();
    },
    handleClickOpen(opening) {
      if (opening) {
        this.openedTimestamp = new Date().toISOString();
      }
    },
    handleScreenshotClick() {
      this.handlePageTrackerEvent(
        LATEST_CATEGORIES.latest,
        EVENT_ACTIONS.clicked,
        "Screenshot Latest"
      );

      document.activeElement.blur();

      this.screenShotting = true;

      html2canvas(document.querySelector("#latest-dashboard"), {
        useCORS: true,
        scale: 1.1,
      }).then((canvas) => {
        try {
          const linkSource = canvas.toDataURL("image/png");
          const downloadLink = document.createElement("a");
          const fileName = "screenshot_of_latest.jpg";

          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          this.screenShotting = false;
        } catch (e) {
          console.error(e);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.v-overlay {
  left: 0 !important;
  background-color: rgba(0, 0, 0, 0) !important;
}

.v-overlay--active.v-overlay {
  background-color: rgba(0, 0, 0, 0.75) !important;
}

.copy-overlay-indicator {
  width: 150px;
  height: 120px;
  background-color: green;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  font-size: large;
}

.screenshot-btn-holder {
  position: absolute;
  top: 20px;
  right: 120px;
}
</style>
